import React from 'react';
import { Link } from 'react-router-dom';
import { UserPlus } from 'lucide-react';
import { createPageUrl } from '../../utils';

export default function DebtorHeader() {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Dashboard Arsip Debitur</h1>
        <p className="text-gray-500 mt-1">Manajemen data dan dokumen debitur</p>
      </div>
      <Link to={createPageUrl('DebtorForm')}>
        <button className="flex items-center gap-2 px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-lg transition-colors">
          <UserPlus className="w-4 h-4" />
          Tambah Debitur
        </button>
      </Link>
    </div>
  );
}
